import React from "react";
import { Box, Button, SwipeableDrawer } from "@mui/material";

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  btnText?: string;
  onBtnClick?: () => void;
  showCloseIcon?: boolean;
}

const BottomSheet: React.FC<BottomSheetProps> = ({
  open,
  onClose,
  children,
  btnText,
  onBtnClick,
}) => {
  const contentBoxSx = {
    position: "absolute" as "absolute",
    width: "100%",
    maxHeight: "90vh",
    backgroundColor: "background.paper",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    boxShadow: 24,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    pt: 2,
    pb: 2,
    px: 3,
    height: "auto",
  };

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      ModalProps={{
        slotProps: {
          backdrop: {
            style: {
              alignItems: "flex-end",
              justifyContent: "center",
            },
          },
        },
        sx: {
          alignItems: "flex-end",
          justifyContent: "center",
        },
      }}
      PaperProps={{
        sx: {
          ...contentBoxSx,
        },
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 4,
          backgroundColor: "#ccc",
          borderRadius: "2px",
          margin: "8px auto 16px auto",
        }}
      />

      <Box sx={{ flexGrow: 1, overflowY: "auto", mb: 2, pr: 1 }}>
        {children}
      </Box>

      {btnText && (
        <Box sx={{ pt: 2, pb: 2 }}>
          <Button
            onClick={onBtnClick}
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              backgroundColor: "#00B3B5",
              "&:hover": { backgroundColor: "#009999" },
              textTransform: "none",
              height: "48px",
              borderRadius: "8px",
              fontSize: "16px",
            }}
          >
            {btnText}
          </Button>
        </Box>
      )}
    </SwipeableDrawer>
  );
};

export default BottomSheet;
